import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_crhome-interior/artifacts/b8oy9x3t_logo-CRHome-final-04.png" 
              alt="CR Home" 
              loading="lazy"
              className="h-16 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-neutral-400 text-sm font-light">
              Interiorismo y Arquitectura que expresa tu identidad.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-medium mb-4">Enlaces rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-neutral-400 hover:text-white transition-colors duration-200 text-sm">
                  {t.nav.home}
                </a>
              </li>
              <li>
                <a href="https://interiorcosts.emergent.host/portal" target="_blank" rel="noopener noreferrer" data-testid="footer-link-cliente" className="text-neutral-400 hover:text-white transition-colors duration-200 text-sm">
                  {t.nav.clients}
                </a>
              </li>
              <li>
                <a href="https://interiorcosts.emergent.host/proveedores/registro" target="_blank" rel="noopener noreferrer" data-testid="footer-link-proveedor" className="text-neutral-400 hover:text-white transition-colors duration-200 text-sm">
                  {t.nav.suppliers}
                </a>
              </li>
              <li>
                <a href="/proyectos" className="text-neutral-400 hover:text-white transition-colors duration-200 text-sm">
                  Proyectos
                </a>
              </li>
              <li>
                <a href="/blog" className="text-neutral-400 hover:text-white transition-colors duration-200 text-sm">
                  Blog
                </a>
              </li>
              <li>
                <a href="https://shop.crhome.mx/" target="_blank" rel="noopener noreferrer" data-testid="footer-link-tienda" className="text-neutral-400 hover:text-white transition-colors duration-200 text-sm">
                  Tienda CR Home: muebles y decoración
                </a>
              </li>
              <li>
                <a href="/contacto" className="text-neutral-400 hover:text-white transition-colors duration-200 text-sm">
                  {t.nav.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-medium mb-4">Contacto</h3>
            <ul className="space-y-2 text-sm text-neutral-400">
              <li>
                <a href="mailto:admin@crhome.mx" className="hover:text-white transition-colors duration-200">
                  admin@crhome.mx
                </a>
              </li>
              <li>
                <a href="tel:+529841793706" className="hover:text-white transition-colors duration-200">
                  +52 984 179 3706
                </a>
              </li>
              <li>Playa del Carmen, QR</li>
              <li className="pt-2">
                <a 
                  href="https://www.instagram.com/crhome.mx" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors duration-200"
                >
                  <Instagram className="h-4 w-4" />
                  @crhome.mx
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © {currentYear} CR Home. {t.footer.rights}
          </p>
          <div className="flex gap-6 items-center">
            <a href="/politica-de-reembolso" data-testid="footer-link-reembolso" className="text-neutral-500 hover:text-white transition-colors duration-200 text-sm">
              {language === 'es' ? 'Política de reembolso' : 'Refund Policy'}
            </a>
            <a href="#" className="text-neutral-500 hover:text-white transition-colors duration-200 text-sm">
              {t.footer.privacy}
            </a>
            <a href="#" className="text-neutral-500 hover:text-white transition-colors duration-200 text-sm">
              {t.footer.terms}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;